import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  CircularProgress
} from "@mui/material";
import { useTranslation } from "react-i18next";

const ConfirmationDialog = ({
  open,
  handleClose,
  handleConfirm,
  message,
  loader = false,
  confirmLabel,
  cancelLabel,
  title
}) => {
  const { t } = useTranslation();
  const dialogMessage = message ?? t("areYouSure");
  const dialogTitle = title ?? t("confirmAction");
  const dialogConfirmLabel = confirmLabel ?? t("yes");
  const dialogCancelLabel = cancelLabel ?? t("no");

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{dialogTitle}</DialogTitle>

      <DialogContent>
        <DialogContentText>
          {dialogMessage}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={handleClose}
          disabled={loader}
          variant="outlined"
        >
          {dialogCancelLabel}
        </Button>

        <Button
          onClick={handleConfirm}
          disabled={loader}
          color="error"
          variant="contained"
        >
          {loader ? <CircularProgress size={18} color="inherit" /> : dialogConfirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;